module.exports = __webpack_public_path__ + "img/step1.56c1d388.png";